import React, { useEffect, useState } from 'react';

// API/Components
import { ANALYSIS_TYPE, isEmpty, GetBVSModel, formatDateTime } from './enums';
import { BuildDataGridMeasurementCell, BuildDataGridCell } from './ui_helpers';
import NoItemsOverlay from '../components/no_items_overlay';

// Material UI
import { DataGrid } from '@mui/x-data-grid';


// System Trend Report table columns
const columns = [
	{
		field: 'datetime',
		headerName: 'Measurement',
		description: 'Measurement Date and Time',
		minWidth: 170,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => formatDateTime(params.value),
	},
	{
		field: 'voltage',
		headerName: 'System Voltage',
		description: 'System Voltage',
		minWidth: 210,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.SYSTEM_VOLTAGE),
	},
	{
		field: 'current',
		headerName: 'System Current',
		description: 'System Current',
		minWidth: 190,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.CURRENT),
	},
	{
		field: 'temperature',
		headerName: 'Ambient Temp',
		description: 'Ambient Temperature',
		minWidth: 190,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.TEMPERATURE),
	},
	{
		field: 'model',
		headerName: 'Model',
		description: 'BVM Model',
		minWidth: 90,
		flex: 0.5,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridCell(GetBVSModel(params.value)),
	},
	{
		field: 'firmware',
		headerName: 'Firmware',
		description: 'BVS Firmware Version',
		minWidth: 90,
		// flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridCell(params.value),
	},
	{
		field: 'note',
		headerName: 'Note',
		description: 'Measurement Notes',
		minWidth: 190,
		flex: 5,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridCell(params.value, 'left'),
	},
];


export default function UnitTrendReport(props) {
	const { trendData, loading, noCurrentMeasurement } = props;
	
	const [reportTrendData, setReportTrendData] = useState([]);
	const [isLoading, setIsLoading] = useState(loading);
	const [pageSize, setPageSize] = useState(50);
	
	// Filter columns based on noCurrentMeasurement flag
	const visibleColumns = noCurrentMeasurement 
		? columns.filter(col => col.field !== 'current')
		: columns;
	
	useEffect(() => {
		const formattedData = FormatDataForReport(trendData);
		if (formattedData !== undefined && formattedData !== null) {
			var newestAtTop = formattedData.reverse();
			setReportTrendData(newestAtTop);
		}
	}, [trendData]);

	useEffect(() => {
		setIsLoading(loading);
	}, [loading]);
	
	function FormatDataForReport(trendData) {
		setIsLoading(true);
		let rows = [];
		if (trendData !== null && trendData !== undefined && !isEmpty(trendData)) {
			trendData.forEach(meas => {
				rows.push({
					datetime: meas.measurement_date,
					voltage: {
						measurement: meas.voltage.measurement,
						result: meas.voltage.analysis_result,
						out: meas.voltage.analysis_out,
						valid: meas.voltage.analysis_valid,
					},
					current: {
						measurement: meas.current.measurement,
						result: meas.current.analysis_result,
						out: meas.current.analysis_out,
						valid: meas.current.analysis_valid,
					},
					temperature: {
						measurement: meas.temperature.measurement,
						result: meas.temperature.analysis_result,
						out: meas.temperature.analysis_out,
						valid: meas.temperature.analysis_valid,
					},
					model: meas.model,
					firmware: meas.firmware,
					note: meas.note,
				});
			});
		}
		
		setIsLoading(false);
		return rows;
	}
	  
	return (
		<DataGrid
			getRowId={(row) => `${row.datetime}`}
			rows={reportTrendData}
			columns={visibleColumns}
			loading={isLoading}
			density="compact"
			pageSize={pageSize}
			onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
			pageSizeOptions={[25, 50, 100]}  // Max pagination size for DataGrid (Free Edition) is 100
			slots={{
				noRowsOverlay: NoItemsOverlay,
			}}
			slotProps={{
				noRowsOverlay: { noItemsText: 'No System Trend Data' },
			}}
			sx={{
				padding: 1,
				height: '100%'
			}}
		/>
	);
}